import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { Description, GetApp } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button';
import { useDownloadCertificate } from '../../../common/certificates/useDownloadCertificate';

export const CertificateDownloadScreen = () => {
  const { certificateId } = useParams<{ certificateId: string }>();
  const history = useHistory();
  const { download, downloading } = useDownloadCertificate();
  const [status, setStatus] = useState<'loading' | 'done' | 'failed'>('loading');

  const run = () => download(certificateId).then((ok) => setStatus(ok ? 'done' : 'failed'));

  useEffect(() => {
    run();
  }, [certificateId]);

  return (
    <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' minHeight='60vh' px={2}>
      {status === 'loading' ? (
        <CircularProgress size={28} />
      ) : (
        <Description style={{ fontSize: 40, color: '#9E9E9E' }} />
      )}
      <Typography style={{ fontSize: 18, fontWeight: 600, color: '#333', marginTop: 16 }}>
        {status === 'loading' && 'Preparing your certificate'}
        {status === 'done' && 'Your certificate has downloaded'}
        {status === 'failed' && 'This certificate is not available'}
      </Typography>
      <Box display='flex' mt={3} style={{ gap: '8px' }}>
        {status !== 'loading' && (
          <TabletButton variant='outlined' color='primary' onClick={() => history.push('/warmth/my-elements')}>
            Go to dashboard
          </TabletButton>
        )}
        {status === 'done' && (
          <TabletButton variant='contained' color='primary' startIcon={<GetApp />} disabled={downloading} onClick={run}>
            Download again
          </TabletButton>
        )}
      </Box>
    </Box>
  );
};
